import request from '../request'

export default {
  getImagenesSatelite(data) {
    return request.get(`satelite_imagen/${data.ID_INCENDIO}`)
  },
  deleteImagenIncendio(data) {
    return request.delete(`incendio_imagen/${data.ID_INCENDIO}/${data.ID_INCENDIO_IMAGEN}`)
  },
  getImagenesIncendio(data) {
    return request.get(`incendio_imagen/${data}`)
  },
  setImagenesIncendio(data) {
    return request.post(`incendio_imagen/${data.ID_INCENDIO}`, data.imagenes)
  }
}
